import { ToastService } from './../../service/toast.service';
import { ParametersService } from './../../service/parameters.service';
import { NgbModalRef, ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VehicleSettings, CheckListVehicle } from './../../model/settings.model';
import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { uid } from 'uid';
import { SubmenuOption } from '../submenu/submenu.component';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Component({
  selector: 'app-parameters-check-list',
  templateUrl: './parameters-check-list.component.html',
  styleUrls: ['./parameters-check-list.component.less']
})
export class ParametersCheckListComponent implements OnInit {

  @Input() vehicle: VehicleSettings;
  @Input() company: boolean;
  modalRef: NgbModalRef
  @ViewChild('content') content: ElementRef;
  reportsType = ['simple', 'state']
  newElement: CheckListVehicle
  submenuOptions: SubmenuOption[];

  constructor(private modalService: NgbModal,
    private readonly i18n: I18n,
    private readonly _parametersService: ParametersService,
    private readonly _toastService: ToastService) 
    {}


  handleSubmenuSelection( e: number, id: number) {
    console.log("subOptions handler modi",this.submenuOptions[e].handler);
    this.submenuOptions[e].handler(id);
  }
  
  changetoggle(type: string, value: string, result: boolean) {
    if (result) {
      this.newElement[type].push(value)
    } else {
      let index = this.newElement[type].indexOf(value)
      this.newElement[type].splice(index, 1)
    }
  }
  ngOnInit() {
    if (this.vehicle.checklist === undefined)
      this.vehicle.checklist = []

      this.submenuOptions = [
        {
          labelFr: this.i18n({
            id: 'Modify',
            value: 'Modifier',
            description: 'Modifier',
            meaning: 'Modifier'
          }),
          handler: (e) => {
            console.log("Index ###", e);
            this.open(e)
          }
        },
        {
          labelFr: this.i18n({
            id: 'Delete',
            value: 'Supprimer',
            description: 'Supprimer',
            meaning: 'Supprimer'
          }),
          handler: (e) => {
            this.del(e)
          }
        }
      ]
  }

  addNewElement() {
    if (this.modalRef)
      this.modalRef.close()

    this.newElement.reportType.sort((a, b) => {
      if (a < b) { return -1; }
      if (a > b) { return 1; }
      return 0;
    })
    this.newElement.classIds.sort((a: any, b: any) => {
      if (a.display < b.display) { return -1; }
      if (a.display > b.display) { return 1; }
      return 0;
    })

    if (this.newElement.id === null) {
      this.vehicle.checklist.push(this.newElement)
      this.newElement.id = uid(10)
    } else {
      let index = this.vehicle.checklist.findIndex(l => { return l.id === this.newElement.id })
      this.vehicle.checklist[index] = this.newElement
    }

    this.saveVehicle()
    console.log(this.newElement);
  }

  del(id: string) {
    let index = this.vehicle.checklist.findIndex(l => { return l.id === id })
    this.vehicle.checklist.splice(index, 1)
    this.saveVehicle()
  }



  saveVehicle() {
    this._toastService.toastOpen(true);
    this._parametersService.saveVehicle(this.vehicle, this.company).then(() => {
      this._toastService.toastOpen(false);
    })
  }

  open(id: string) {

    this.newElement = { id: null, display: '', reportType: ['simple', 'state'], value: true, classIds: [] }

    if (id) {
      let index = this.vehicle.checklist.findIndex(l => { return l.id === id })
      this.newElement = JSON.parse(JSON.stringify(this.vehicle.checklist[index]))
    }
    this.modalRef = this.modalService.open(this.content, { backdropClass: 'backdropClassModal' });
    this.modalRef.result.then((result) => {
    }, (reason) => {
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/element/parameters-check-list/parameters-check-list.component.ts